import { Component, Inject, Input } from "@angular/core";
import { CommonModule } from '@angular/common';
import { FieldOkItemComponent } from "@softline/dynamic";

@Component({
    selector: 'soft-field-ok-data-view',
    imports: [CommonModule],
    templateUrl: './zbewegungsart.list-view.html',
    styleUrls: ['./zbewegungsart.list-view.scss']
})
export class ZbewegungsartListView implements FieldOkItemComponent<any>{

  @Input() item: any;

  constructor() {
  }
}
